export function returnExtensionIcon (extension, faIconSize = 'fa-3x') {
  let icon = extensionIconClass(extension)
  return `<i class="fa ${icon} ${faIconSize}" /></i>`
}

export function extensionIconClass (extension) {
  let icon = ''
  switch (extension.toLowerCase()) {
    case '.pdf':
      icon = 'file-pdf'
      break
    case '.doc':
    case '.docx':
    case '.dotx':
      icon = 'file-word'
      break
    case '.xls':
    case '.xlsx':
    case '.xlsm':
    case '.xlst':
      icon = 'file-excel'
      break
    case '.ppt':
    case '.pptx':
      icon = 'file-powerpoint'
      break
    case '.jpg':
    case '.jpeg':
    case '.gif':
    case '.png':
    case '.svg':
      icon = 'image'
      break
    default:
      icon = 'question'
      break
  }
  return `fa-${icon}`
}
